exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.assignee-info[data-v-2e743a40] {\n  background: #fff;\n  -webkit-box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);\n          box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);\n  min-height: 68px;\n}\n.assignee-content[data-v-2e743a40] {\n  color: #4c5669;\n  font-family: Roboto;\n  font-size: 16px;\n  line-height: 20px;\n}\n.assignee-title[data-v-2e743a40] {\n  opacity: 0.7;\n  color: #808d98;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n}\n.select[data-v-2e743a40]:hover {\n  background: #f4f5f7;\n}\n.no-permission[data-v-2e743a40] {\n  margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e743a40","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/claims/ClaimAssigneInfo.vue
// module id = UMxM
// module chunks = 0